import { scholarshipMembersDataset } from '@/lib/member-views/datasets/scholarshipMembers.dataset';
import type { ScholarshipMemberRow } from '@/lib/members/members.types';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PhoneCell } from '../cells/PhoneCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<ScholarshipMemberRow>['cellOverrides'] = {
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  phone: (row) => <PhoneCell mobile={row.mobilePhone} home={row.phone} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * Scholarship Members: the practice's members on a Scholarship billing schedule.
 *
 * A function declaration for the same reason as `AllActiveMembersView`: the view registry and the
 * shell import each other, and a hoisted function survives that cycle where a `const` might not.
 */
export function ScholarshipMembersView() {
  return <MemberViewShell dataset={scholarshipMembersDataset} cellOverrides={cellOverrides} />;
}
